import React, { useState, useEffect } from "react";
import HrmSidebar from "Components/Common/HrmSidebar";
import PagesWrapper from "Components/Common/Pages/PagesWrapper";
import AppWrapper from "Components/Routes/AppWrapper";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import AssetApi from "api/hrmapi/assests";

function AssestsType() {
  const navigate = useNavigate();
  let params = useParams();
  const [updateAssestsType, setUpdateAssestsType] = useState({
    id: "",
    name: "",
    company_id: "",
    created_at: "",
    updated_at: "",
  });
  const handleNavgetAll = () => {
    setTimeout(() => {
      navigate(`/all-asset-type`);
    }, 2000);
  };
  const inputOnChange = (e) => {
    const { name, value } = e.target;
    setUpdateAssestsType({
      ...updateAssestsType,
      [name]: value,
    });
  };
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const isDetailsPath = location.pathname.includes("/asset-type/details");
  useEffect(() => {
    setLoading(true);
    AssetApi.viewAssetTypeApi(params)
      .then((response) => {
        setUpdateAssestsType({
          id: response.data.id,
          name: response.data.name,
          company_id: response.data.company_id,
          created_at: response.data.created_at,
          updated_at: response.data.updated_at,
        });
        setLoading(false);
      })
      .catch((error) => {      
        const errorMessage = error.response?.data.message
          ? error.response.data.message
          : "An error occurred";

        toast.error(`Error: ${errorMessage}`);
        setLoading(false);
      });
  }, []);
  const handleAssestsTypeUpdate = (e) => {
    e.preventDefault();
    setLoading(true);
    AssetApi.updateAssetTypeApi(params.id, {
      asset_type: {
        name: updateAssestsType.name,
        company_id: updateAssestsType.company_id,
      },
    })
      .then((response) => {
        handleNavgetAll();
        const Message = response ? response.data.message : "An error occurred";
        toast.success(`${Message}`);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        const errorMessage = error.response?.data.message
          ? error.response.data.message
          : "An error occurred";

        toast.error(`Error: ${errorMessage}`);
      });
  };
  return (
    <AppWrapper sideBar={<HrmSidebar />}>
      <PagesWrapper>
        <div className="w-full flex mb-4 justify-between items-center pt-4">
          {isDetailsPath ? (
            <div className="text-24">Assets Type #{params.id}</div>
          ) : (
            <div className="text-24">Assets Type</div>
          )}
        </div>

        <div className="bg-white rounded-3xl w-full mt-5 min-h-[60vh]">
          <form onSubmit={handleAssestsTypeUpdate}>
            <div className="w-full flex gap-5 flex-wrap pl-4 pr-4">
              <div className="w-[32%]">
                <div className="flex w-full pt-5 pb-5">
                  <div>Name</div>
                  <div className="text-red">*</div>
                </div>
                <div>
                  <input
                    className="form-control"
                    name="name"
                    value={updateAssestsType.name}
                    onChange={inputOnChange}
                    required
                  />
                </div>
              </div>
              <div className="flex w-full  pr-4 justify-end">
                <button
                  className={
                    loading
                      ? "w-[14%] btn-primary cursor-not-allowed"
                      : "w-[14%] btn-primary"
                  }
                  type="submit"
                  disabled={loading}
                >
                  Update Assets Type
                </button>
              </div>
            </div>
          </form>
        </div>
      </PagesWrapper>
    </AppWrapper>
  );
}

export default AssestsType;
